import React, { useEffect, useState } from 'react';
import { PDFDocument, rgb } from 'pdf-lib';
import { DNA } from 'react-loader-spinner';
import UserCertificateServices from '../../services/UserCertificateServices';
import logsUserService from '../../services/UserLogServices';
import CertificateServices from '../../services/CertificateServices';

const CertificatesFunctionComponent = ({ country, city, name, lastName }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isDownloading, setIsDownloading] = useState(false);
    const [certicatesPercentage, setCerticatesPercentage] = useState([]);
    const [certificateData, setCertificateData] = useState([]);
    const [error, setError] = useState();

    const token = sessionStorage.getItem('token');
    const id_user = sessionStorage.getItem('id_user');

    const is_qr = sessionStorage.getItem('is_qr');

    useEffect(() => {
        const getCertificates = async () => {
            try {
                const userData = {
                    user_id: Number(id_user),
                    event_id: Number(sessionStorage.getItem('id_event'))
                };

                const getCertificates = await UserCertificateServices(token, userData)
                const getFileCertificate = await CertificateServices(token, userData.event_id);

                console.log(getFileCertificate);

                setCerticatesPercentage(getCertificates);
                setCertificateData(getFileCertificate);

                console.log(certicatesPercentage)
            } catch (error) {
                setError(error);
            }
        }

        getCertificates();
    }, []);

    const openModal = () => {
        const normalizedCountry = removeAccents((sessionStorage.getItem('country') || '').toLowerCase());
        const normalizedCity = removeAccents((sessionStorage.getItem('city') || '').toLowerCase());

        console.log(normalizedCity, normalizedCountry);

        if (normalizedCity === 'quetzaltenango') {
            setIsModalOpen(true);
        } else {
            switch (normalizedCountry) {
                case 'guatemala':
                    setIsModalOpen(true);
                    break;
                case 'honduras':
                    setIsModalOpen(true);
                    break;
                case 'costa rica':
                    setIsDownloading(true);
                    downloadCertificate(`${process.env.PUBLIC_URL}/CLA24DI00283_Certificado_MédicosInnovadores210824-costa-rica.pdf`);
                    break;
                case 'republica dominicana':
                    setIsModalOpen(true);
                    //setIsDownloading(true);
                    //downloadCertificate(`${process.env.PUBLIC_URL}/CLA24DI00283_Certificado_MédicosInnovadores210824-republica-dominicana.pdf`);
                    break;
                default:
                    setIsModalOpen(true);
            }
        }
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    const removeAccents = (str) => {
        return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    }

    // const survey = async () => {
    //     let surveyUrl = '';
    //     const normalizedCountry = removeAccents((sessionStorage.getItem('country') || '').toLowerCase());
    //     const normalizedCity = removeAccents((sessionStorage.getItem('city') || '').toLowerCase());

    //     console.log(normalizedCity, normalizedCountry)

    //     if (normalizedCity === 'quetzaltenango') {
    //         surveyUrl = 'https://es.surveymonkey.com/r/MEDINQUETZ24';
    //     } else {
    //         switch (normalizedCountry) {
    //             case 'guatemala':
    //                 surveyUrl = 'https://es.surveymonkey.com/r/MEDINGUA24';
    //                 break;
    //             case 'honduras':
    //                 surveyUrl = 'https://es.surveymonkey.com/r/MEDINHON24';
    //                 break;
    //             case 'republica dominicana':
    //                 surveyUrl = 'https://es.surveymonkey.com/r/MEDINDOM24';
    //                 break;
    //             default:
    //                 surveyUrl = 'https://es.surveymonkey.com/r/MEDINGUA24';
    //                 break;
    //         }
    //     }

    //     if (surveyUrl) {
    //         const surveyWindow = window.open(surveyUrl, '_blank');
    //         const checkClosed = setInterval(() => {
    //             if (surveyWindow.closed) {
    //                 clearInterval(checkClosed);
    //                 if (normalizedCity === 'quetzaltenango') {
    //                     const pdfUrl = getCertificateUrl(null, normalizedCity);
    //                     downloadCertificate(pdfUrl);
    //                 } else {
    //                     const pdfUrl = getCertificateUrl(normalizedCountry, null);
    //                     downloadCertificate(pdfUrl);
    //                 }
    //             }
    //         }, 1000);
    //     }
    // };

    const survey = async () => {
        let surveyUrl = '';
        const normalizedCountry = removeAccents((sessionStorage.getItem('country') || '').toLowerCase());
        const normalizedCity = removeAccents((sessionStorage.getItem('city') || '').toLowerCase());


        // buscamos el pais en el objeto
        const certificateByCountry = certificateData.filter(data => {
            return data.country_certificate.toLowerCase() === normalizedCity || data.country_certificate.toLowerCase() === normalizedCountry;
        });

        const defaultSurvey = certificateData.filter(data => {
            return data.country_certificate.toLowerCase() === 'clat';
        });

        // Si existe un certificado para el país o ciudad del sessionStorage, usamos ese, sino usamos el default
        if (certificateByCountry.length > 0) {
            surveyUrl = certificateByCountry[0].survey_certificate;
        } else if (defaultSurvey.length > 0) {
            surveyUrl = defaultSurvey[0].survey_certificate;
        } else {
            surveyUrl = null; // O asigna otro valor por defecto si es necesario
        }

        console.log(surveyUrl);

        if (surveyUrl) {
            const surveyWindow = window.open(surveyUrl, '_blank');
            const checkClosed = setInterval(() => {
                if (surveyWindow.closed) {
                    clearInterval(checkClosed);

                    // Verificamos si tenemos un certificado específico por país o usamos el default
                    const certificateCountry = certificateByCountry.length > 0
                        ? certificateByCountry[0].country_certificate
                        : defaultSurvey.length > 0
                            ? defaultSurvey[0].country_certificate
                            : 'clat';  // Usa 'clat' si no se encuentra otro valor ni en el default

                    // Genera la URL para el PDF del certificado
                    const pdfUrl = getCertificateUrl(certificateCountry);
                    downloadCertificate(pdfUrl);
                }
            }, 1000);
        }
    }

    // const getCertificateUrl = (country, city) => {
    //     if (city === 'quetzaltenango') {
    //         return `${process.env.PUBLIC_URL}/CLA24DI00283_Certificado_MédicosInnovadores210824-quetzaltenango.pdf`;
    //     } else {
    //         switch (country) {
    //             case 'guatemala':
    //                 return `${process.env.PUBLIC_URL}/CLA24DI00283_Certificado_MédicosInnovadores210824-guatemala.pdf`;
    //             case 'honduras':
    //                 return `${process.env.PUBLIC_URL}/CLA24DI00283_Certificado_MédicosInnovadores210824-Honduras.pdf`;
    //             case 'costa rica':
    //                 return `${process.env.PUBLIC_URL}/CLA24DI00283_Certificado_MédicosInnovadores210824-costa-rica.pdf`;
    //             case 'republica dominicana':
    //                 return `${process.env.PUBLIC_URL}/CLA24DI00283_Certificado_MédicosInnovadores210824-republica-dominicana.pdf`;
    //             default:
    //                 return `${process.env.PUBLIC_URL}/CLA24DI00283_Certificado_MédicosInnovadores210824-streaming.pdf`;
    //         }
    //     }
    // };

    const getCertificateUrl = (location) => {

        const getUrlPdf = certificateData.filter(data => {
            return data.country_certificate === location;
        });

        if (location) {
            switch (location) {
                case location:
                    return getUrlPdf[0].certificate
                default:
                    return getUrlPdf[0].certificate;
            }
        }
    }

    const downloadCertificate = async (pdfUrl) => {
        try {
            if (!pdfUrl) return;

            setIsDownloading(true);

            const idUser = sessionStorage.getItem('id_user');
            const token = sessionStorage.getItem('token');

            const url_local = 'http://localhost:8000';
            const url_prod = 'https://medico.innovador.interactiva.net.co';

            const response = await fetch(url_prod+pdfUrl);
            const existingPdfBytes = await response.arrayBuffer();
            const pdfDoc = await PDFDocument.load(existingPdfBytes);
            const pages = pdfDoc.getPages();
            const firstPage = pages[0];
            const { width } = firstPage.getSize();
            const fontSize = 65;
            const text = `${name} ${lastName}`;
            const x = (width - fontSize * text.length / 2) / 2;
            firstPage.drawText(text, {
                x: x,
                y: 515,
                size: fontSize,
                fontFamily: 'Apis-Bold-1',
                fontWeight: 'bold',
                color: rgb(1, 1, 1) // blanco
            });

            const pdfBytes = await pdfDoc.save();
            const fileName = pdfUrl.substring(pdfUrl.lastIndexOf('/') + 1);
            const blob = new Blob([pdfBytes], { type: 'application/pdf' });

            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = fileName;

            if (is_qr) {
                logsUserService(idUser, 'download certificates from qr', window.location.href)
            } else {
                logsUserService(idUser, 'download certificates live', window.location.href)
            }

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            setIsDownloading(false);
        } catch (error) {
            console.error('Error editing PDF:', error);
            setIsDownloading(false);
        }
    };

    return (
        <>
            <div>
                {is_qr ? (
                    <button
                        className={`flex items-center justify-center px-8 py-3 text-2xl rounded-lg w-full mt-4 bg-blue-500 text-white hover:bg-blue-600 disabled:bg-blue-400 disabled:text-gray-600 disabled:cursor-not-allowed
                            }`}
                        onClick={openModal}
                    >
                        <span className="mr-2 text-center w-full">Descargar</span>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke-width="1.5"
                            stroke="currentColor"
                            className="w-6 h-6 ml-2"
                        >
                            <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3"
                            />
                        </svg>
                    </button>
                ) : (
                    certicatesPercentage.map((data, index) => (
                        <div key={index}>
                            <button
                                className={`flex items-center justify-center px-8 py-3 text-2xl rounded-lg w-full mt-4 bg-blue-500 text-white hover:bg-blue-600 disabled:bg-blue-400 disabled:text-gray-600 disabled:cursor-not-allowed ${data.viewed_percentage < 100 ? 'cursor-not-allowed' : ''
                                    }`}
                                disabled={data.viewed_percentage < 100}
                                onClick={openModal}
                            >
                                <span className="mr-2 text-center w-full">{data.viewed_percentage < 100 ? `${data.viewed_percentage}%` : 'Descargar'}</span>
                                {data.viewed_percentage < 100 ? '' : (
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        strokeWidth="1.5"
                                        stroke="currentColor"
                                        className="w-6 h-6 ml-2"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3"
                                        />
                                    </svg>
                                )}
                            </button>
                        </div>
                    ))
                )}
            </div>

            {/* Modal */}
            {isModalOpen && (
                <div id="static-modal" className="fixed inset-0 z-50 flex justify-center items-center w-full h-full bg-black bg-opacity-50">
                    <div className="relative p-4 w-full max-w-md bg-white rounded-lg shadow dark:bg-gray-700">
                        {/* Modal header */}
                        <div className="flex items-center justify-between p-2 md:p-5 border-b rounded-t dark:border-gray-600">
                            <h3 className="text-xl font-semibold text-gray-900 dark:text-white">
                                Encuesta
                            </h3>
                            <button
                                type="button"
                                className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
                                onClick={closeModal}
                            >
                                <svg className="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
                                    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
                                </svg>
                                <span className="sr-only">Close modal</span>
                            </button>
                        </div>
                        {/* Modal body */}
                        <div className="p-2 md:p-5 space-y-4">
                            <p className="text-base text-justify leading-relaxed text-gray-500 dark:text-gray-400">
                                Nos encantaría conocer tu opinión. Por favor, tómate un momento para completar esta breve encuesta. ¡Agradecemos mucho tu tiempo y comentarios!
                            </p>
                        </div>
                        {/* Modal footer */}
                        <div className="flex items-center justify-center p-1 md:p-5 border-t border-gray-200 rounded-b dark:border-gray-600">
                            <button
                                type="button"
                                className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                                onClick={() => { closeModal(); survey(); }}
                            >
                                Continuar
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {isDownloading && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
                    <div className="bg-white rounded-lg p-6 flex flex-col items-center">
                        <DNA
                            visible={true}
                            height="80"
                            width="80"
                            ariaLabel="dna-loading"
                            wrapperStyle={{}}
                            wrapperClass="dna-wrapper"
                        />
                        <p className="mt-4 text-gray-700">Descargando certificado...</p>
                    </div>
                </div>
            )}
        </>
    );
};

export default CertificatesFunctionComponent;
